var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "session" },
    [
      _c("SessionRecorder", {
        attrs: {
          "contact-list": _vm.contactList,
          "pending-contacts": _vm.pendingContacts,
          recorder: _vm.user.recorder,
          "session-list": _vm.sessionList,
          streaming: _vm.user.streaming,
        },
        on: {
          "update:pendingContacts": function ($event) {
            _vm.pendingContacts = $event
          },
          "update:pending-contacts": function ($event) {
            _vm.pendingContacts = $event
          },
        },
      }),
      _vm._v(" "),
      _vm.sessionList.length > 0
        ? _c("SessionList", {
            attrs: {
              recorder: _vm.user.recorder,
              "session-list": _vm.sessionList,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("favorite-dialog", {
        attrs: { "user-id": _vm.user.user_id },
        on: { remove: _vm.getContactList, update: _vm.getContactList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }